<script type="text/ecmascript-6">
    export default {
        computed: {
            technical_should_show() {
                return window.door_designer_options.show_technical;
            },
        }
    }
</script>
